export enum IntroductionGuideStep {
  FirstAndLastNameSet = 'first-and-last-name-set',
  NickSet = 'nick-set',
  AvatarSet = 'avatar-set',
}
